import SeoComponent from "../Course/Components/SeoComponent";
import LoginSignupModal from "../../components/LoginSignupModal";

export const LandingLogin = () => {
  return (
    <div className="custom-theme">
      <SeoComponent
        title={"Seafarers Learning Training Portal"}
        name="Seafarers Learning Training Portal"
        description="eDOT is all about Excellence Developed Over Time."
        route={"/"}
      />

      <div className="login-page-client">
        <LoginSignupModal />
      </div>
    </div>
  );
};

export default LandingLogin;
